import userApi from "./userApi";

/* Invitations au portail client (user-service, a370081). Routes réservées aux
   administrateurs dont le rôle porte accessrestriction_write :
   - POST   /user/client-invitations       { email, organisation } → invitation + lien
   - GET    /user/client-invitations       → liste, sans code
   - DELETE /user/client-invitations/{id}  → annulation d'une invitation non utilisée */

export type EtatInvitation = "EN_ATTENTE" | "UTILISEE" | "EXPIREE" | "ANNULEE";

export interface InvitationClient {
  id: number;
  email: string;
  organisation: string | null;
  etat: EtatInvitation;
  creeePar: string | null;
  creeeLe: string;
  expireLe: string;
  consommeeLe: string | null;
  annuleeLe: string | null;
}

export interface InvitationCreee extends InvitationClient {
  /** Lien d'invitation : renvoyé une seule fois, à la création. */
  lien: string;
  courrielEnvoye: boolean;
}

export async function creerInvitation(email: string, organisation: string): Promise<InvitationCreee> {
  const res = await userApi.post("/user/client-invitations", { email, organisation: organisation || null });
  return res.data;
}

export async function listerInvitations(): Promise<InvitationClient[]> {
  const res = await userApi.get("/user/client-invitations");
  return Array.isArray(res.data) ? res.data : [];
}

export async function annulerInvitation(id: number): Promise<InvitationClient> {
  const res = await userApi.delete(`/user/client-invitations/${id}`);
  return res.data;
}
